var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSdStake = function SvgSdStake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.197.384A.353.353 0 0 1 9.49.85L8.39 3.974a.353.353 0 0 1-.631.07l-.235-.376-4.241 2.65-.437-.698a2.38 2.38 0 0 1 .758-3.28L5.826.951 5.57.54a.353.353 0 0 1 .34-.538l3.288.382Zm-4.446 7.24A3.203 3.203 0 0 0 3.578 12l4.316-2.491a2.38 2.38 0 0 0 .87-3.252l-.41-.713-3.603 2.08Z",
    fill: "currentColor"
  })));
};
export default SvgSdStake;